import { makeApiRequest } from '@/src/lib/api-request'
import { useUser } from '@/src/store/user-store'
import { useMutation } from '@tanstack/react-query'
import { usePostHogEvents, EVENTS } from '@/lib/posthog-events'

export const useLogoutMutation = () => {
  const { refreshToken } = useUser()
  const { trackEvent } = usePostHogEvents()
  return useMutation({
    mutationKey: ['user', 'logout'],
    mutationFn: async () => {
      await makeApiRequest({
        method: 'POST',
        url: '/User/logoutuser',
        data: {
          refresh_token: refreshToken,
        },
        isAuthenticated: true,
        fallbackError: 'Error while logging out',
        isV3Api: true,
      })
    },
    onSuccess: () => {
      trackEvent(EVENTS.USER_LOGGED_OUT)
    }
  })
}
